import type { CalendarHighlight } from '@massilia/ui'

import { type FeaturedFlightDates, useGetFeaturedFlightDatesQuery } from '@massilia/queries'
import { useMemo } from 'react'

/**
 * Jours mis en avant de `from` vers `to`, prêts pour le calendrier (#46) : vols
 * directs en vert, vols avec escale recensés en ambre. Rien tant que l'une des
 * deux villes manque.
 */
export function useFeaturedFlightHighlights(from?: string, to?: string): CalendarHighlight[] {
  const { data } = useGetFeaturedFlightDatesQuery(from || undefined, to || undefined)

  return useMemo(() => {
    if (!from || !to || !data) return []
    return [
      toHighlight(data.direct, 'Vol direct', 'success'),
      toHighlight(data.withStop, '1 escale', 'warning'),
    ].filter((h) => h !== undefined)
  }, [data, from, to])
}

function toHighlight(
  group: FeaturedFlightDates,
  label: string,
  tone: CalendarHighlight['tone']
): CalendarHighlight | undefined {
  if (group.dates.length === 0) return undefined
  return {
    // Minuit local : react-day-picker compare des jours du calendrier, pas des instants UTC.
    dates: group.dates.map((iso) => {
      const [year, month, day] = iso.split('-').map(Number)
      return new Date(year, month - 1, day)
    }),
    label: group.carrierNames.length > 0 ? `${label} avec ${group.carrierNames.join(', ')}` : label,
    tone,
  }
}
